/** @file Asks the live socket for a page of the render feed (newest first, before a seq). */
import { liveSession } from './liveSession';

/** `{ t: 'renders', before }`; false while no project is live or the socket is down. */
export function requestRenders(before: number | null): boolean {
  return liveSession.get()?.send({ t: 'renders', before }) ?? false;
}
